export const escapeHtml = (unsafe: string): string => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const allowedTags = new Set<string>([
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'em',
  'i',
  'kbd',
  'mark',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
]);

const allowedAttributes = new Set<string>([
  'class',
  'colspan',
  'datetime',
  'hidden',
  'href',
  'id',
  'lang',
  'referrerpolicy',
  'rel',
  'target',
  'title',
  'translate',
]);

const htmlTagRegExp = /<(\/.*|.*)>/g;

const htmlAttributeRegExp = /\s\w+=.*('|")/g;

/**
 * HTML sanitizer that will return empty valus if unsafe HTML is found
 * See specs for an example of what is considered safe and unsafe and how it behaves
 * This was written as an isomorphic helper to safely send and parse HTML to ourselves without adding a whole library to our bundle size
 * Our needs are small and we can always replace this with a real one like DOMPurify or the Sanitizer API once it's more supported by browsers
 */
export const roughSanitizeHtml = (unsafe: string): string => {
  return unsafe
    .replaceAll(htmlTagRegExp, (tag) => {
      const tagNamesMatch = tag.match(/(?<=<)\w*/g) ?? [''];

      const allTagsValid = tagNamesMatch.reduce((valid, tagName) => {
        // TODO fix regExp matcher so empty strings aren't matched
        if (!tagName) return valid;

        return valid && allowedTags.has(tagName);
      }, true);

      return allTagsValid ? tag : '';
    })
    .replaceAll(htmlAttributeRegExp, (attribute) => {
      const attributeNamesMatch = attribute.match(/\w+(?==)/g) ?? [''];

      const allAttributesValid = attributeNamesMatch.reduce(
        (valid, attribute) => {
          return valid && allowedAttributes.has(attribute);
        },
        true,
      );

      return allAttributesValid ? attribute : '';
    });
};
